import { isPeopleLikeCameraType } from '../constants/adminPageConstants';

export const useFormValidation = () => {
  const shouldIncludeRtspUrl = (url) => {
    const trimmed = (url || '').trim();
    return trimmed !== '' && !trimmed.includes('*');
  };

  const validateForm = ({ data, level, mode }) => {
    const errors = {};

    if (!data.name?.trim()) errors.name = 'Название обязательно';
    if (!data.owner) errors.owner = 'Выберите владельца';

    if (level === 'cameras') {
      if (mode === 'create' && !data.rtsp_url?.trim()) {
        errors.rtsp_url = 'RTSP URL обязателен';
      }
      if (data.frame_interval_sec <= 0) errors.frame_interval_sec = 'Должно быть > 0';
      if (data.retention_minutes <= 0) errors.retention_minutes = 'Должно быть > 0';
      if (!data.type) errors.type = 'Выберите тип камеры';
      // ТЗ №2 §10.1: единый часовой пояс камеры обязателен (IANA-имя).
      if (!data.display_timezone?.trim()) errors.display_timezone = 'Выберите часовой пояс камеры';

      const interval = Number(data.slow_retry_interval_minutes);
      if (!Number.isInteger(interval) || interval < 1 || interval > 1440) {
        errors.slow_retry_interval_minutes = 'Введите целое число от 1 до 1440';
      }

      if (data.live_enabled) {
        if (!data.live_rtsp_url?.trim() && !data.masked_live_rtsp_url) errors.live_rtsp_url = 'URL для live обязателен';
      }

      if (data.archive_enabled) {
        if (!data.archive_rtsp_url?.trim() && !data.masked_archive_rtsp_url) errors.archive_rtsp_url = 'URL для Архива обязателен';
        if (data.archive_retention_days <= 0) errors.archive_retention_days = 'Должно быть > 0';
        if (data.hot_buffer_retention_hours <= 0) errors.hot_buffer_retention_hours = 'Должно быть > 0';
        if (data.archive_segment_duration_minutes <= 0) errors.archive_segment_duration_minutes = 'Должно быть > 0';
      }

      if (data.detection_configs) {
        try {
          JSON.parse(data.detection_configs);
        } catch {
          errors.detection_configs = 'Невалидный JSON';
        }
      }

      if (isPeopleLikeCameraType(data.type)) {
        const shifts = data.shifts || [];

        if (!shifts.length) {
          errors.shifts = 'Добавьте хотя бы одну смену';
        } else {
          shifts.forEach((shift, idx) => {
            if (!shift.start || !shift.end) {
              errors[`shift_${idx}`] = 'Заполните время';
              return;
            }

            for (let i = 0; i < idx; i += 1) {
              const prev = shifts[i];
              if (
                prev.start &&
                prev.end &&
                !(shift.end <= prev.start || shift.start >= prev.end)
              ) {
                errors[`shift_${idx}`] = 'Смены не должны пересекаться';
              }
            }
          });
        }
      }
    }

    return errors;
  };

  return { shouldIncludeRtspUrl, validateForm };
};
